import { p as proxyCustomElement, H, h, F as Fragment, a as Host } from './index.js';

const dividerCss = ":host{align-items:center;display:flex;justify-content:center}.line{background-color:var(--jw-theme-surface-divider-color);flex:1;height:1px;width:100%}.or-text{background-color:var(--jw-theme-surface-tile-bg-color);color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:700;letter-spacing:.03em;line-height:1rem;padding:.25rem .75rem;text-transform:uppercase}:host([type=vertical]){min-height:100%;width:1px}:host([type=vertical]) .line{height:100%;max-height:100%;min-height:1.5rem;width:100%}";

const WuiDivider = /*@__PURE__*/ proxyCustomElement(class WuiDivider extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Type
         */
        this.type = 'horizontal';
    }
    render() {
        return (h(Host, { key: '519b295740570d1241e1c23eb02fc96ce7c1e6e6' }, h("div", { key: 'ed37a31da7139fa15412bde1e8bdfb137f1803ac', class: "line" }), this.type === 'horizontal-or' && (h(Fragment, { key: '512030483ddf33f4462f8a29873a32ca021ba3c3' }, h("div", { key: '1907e1f7a9e3681181e2d83188f3d1cfdfe65639', class: "or-text" }, "OR"), h("div", { key: 'f195bac1265c1e83617309e66f9b87adc8ebcae4', class: "line" })))));
    }
    static get style() { return dividerCss; }
}, [257, "wui-divider", {
        "type": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-divider"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-divider":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDivider);
            }
            break;
    } });
}
defineCustomElement();

export { WuiDivider as W, defineCustomElement as d };
